export const featuredPortfolio = [
    {
      id: 1,
      title: "Pixart iOS App",
      img:
        "assets/pixart-portfolio.png",
    },
    {
      id: 2,
      title: "Naruto Sudoku iOS App",
      img:
        "assets/naruto-portfolio.png",
    },
    {
      id: 3,
      title: "iWalle iOS App",
      img:
        "assets/iwalle-portfolio.png",
    },
    {
      id: 4,
      title: "iT-rex 22 React App",
      img:
        "assets/t-rex-portfolio.svg",
    },
    {
      id: 5,
      title: "Aggie Dish iOS App",
      img:
        "assets/aggie-dish-portfolio.png",
    },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "iT-rex 22 React App",
      img:
        "assets/t-rex-portfolio.svg",
    },
  ];
  
  export const mobilePortfolio = [
    {
      id: 1,
      title: "Pixart iOS App",
      img:
        "assets/pixart-portfolio.png",
    },
    {
      id: 2,
      title: "Naruto Sudoku iOS App",
      img:
        "assets/naruto-portfolio.png",
    },
    {
      id: 3,
      title: "iWalle iOS App",
      img:
        "assets/iwalle-portfolio.png",
    },
    {
      id: 4,
      title: "Aggie Dish iOS App",
      img:
        "assets/aggie-dish-portfolio.png",
    },
  ];
 
  